// extracted by mini-css-extract-plugin
export var callCard = "_qx-0";
export var callMessageButton = "_qx-1";
export var helpIcon = "_qx-3";
export var helpIconContainer = "_qx-4";
export var verticalDivider = "_qx-2";